export default __webpack_public_path__ + "static/media/news3.c8c44a5c.jpg";